import React, { memo } from "react";
import Card from "react-bootstrap/Card";
import {
  IconReceipt2,
  IconFileInfo,
  IconShieldStar,
  IconBasketDollar,
  IconRecycle,
  IconChartBarPopular,
  IconTargetArrow,
  IconChartDots,
  IconPlus,
} from "@tabler/icons-react";
import "./dashboard.css";
import { Button } from "react-bootstrap";

// const Dashboard = function Dashboard(props) {
//   return (
//     <div className="dashboard"><h1>testing dashboard</h1></div>
//   )
// };
const Dashboard = memo(function Dashboard(props) {
  return (
    <>
      {/* <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">Aspetto Portal Overview</h2>
          </div>
          <div className="col d-none d-sm-inline">
            <Button className="btn-warning float-end ">
              <IconPlus /> Request For Quotation
            </Button>
          </div>
        </div>
      </div>

      <div className="row">
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-blue-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">RFQ</span>
            <IconReceipt2 stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>Request For A Quote</Card.Title>
            <Card.Text>
              Explore this tab for: Initiating a New RFQ, Modifying an existing
              RFQ, Retrieving all available Quotes.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-yellow-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">RFI</span>
            <IconFileInfo stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>Request For Information</Card.Title>
            <Card.Text>
              Utilize this tab for: Initiating a New RFI/Sources Sought,
              Modifying an existing RFI/Sources Sought, Retrieving all
              RFIs/Sources Sought.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-lime-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">RMA</span>
            <IconShieldStar stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>Warranty/repairs</Card.Title>
            <Card.Text>
              Opt for this tab to: Generate a New RETURN MERCHANDISE
              AUTHORIZATION request, Update and track existing RMAs.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-purple-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">POs</span>
            <IconBasketDollar stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>Purchase Orders</Card.Title>
            <Card.Text>
              Access this tab for: Retrieving all Purchase Orders (POs),
              Gathering information on Margins for each Quote.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-pink-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">LIFE CYCLE</span>
            <IconRecycle stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>Sales Life Cycle</Card.Title>
            <Card.Text>
              Navigate to this tab to: View/Update the Sales Life Cycle for
              various contract types. Modify Invoice numbers, Payment details,
              and other contract-related information.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-cyan-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">DHS-CBP</span>
            <IconChartBarPopular stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>DHS-CBP</Card.Title>
            <Card.Text>
              Set and review your sales goals. Use this tab to establish
              targets, assess your sales performance data, gain insights into
              crucial metrics, and inform your decision-making with data-driven
              analysis.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-indigo-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">MY METRICS</span>
            <IconChartDots stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>My Performance Metrics</Card.Title>
            <Card.Text>
              Track and analyze your sales performance. Access this tab for:
              retrieving data on your sales performance, gathering insights on
              key metrics, and making data-driven decisions.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="col-lg-3 col-md-6 mb-4">
        <Card className="dashboard_card card bg-green-lt badge-outline h-100">
          <div className="head_card">
            <span className="title_card">REVENUE GOALS</span>
            <IconTargetArrow stroke={1} />
          </div>
          <Card.Body className="card_content p-0">
            <Card.Title>Revenue Goals</Card.Title>
            <Card.Text>
              Set and review your sales goals. Use this tab to establish
              targets, assess your sales performance data, gain insights into
              crucial metrics, and inform your decision-making with data-driven
              analysis.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
    </div> */}
    </>
  );
});

Dashboard.propTypes = {};

export default Dashboard;
